import { MuiX, MuiIcons } from "@osu/react-ui";

function Toolbar({ fileName: _fileName }) {
  const today = new Date().toISOString();
  const fileName = _fileName || `submissions-${today}`;
  return (
    <MuiX.Toolbar>
      <MuiX.ExportCsv
        options={{
          fileName,
        }}
      >
        Download to CSV <MuiIcons.FileDownload />
      </MuiX.ExportCsv>
    </MuiX.Toolbar>
  );
}

export default Toolbar;
